import { ref as d, h as m } from "vue";
import { Hidden as c, Features as p } from "./index332.js";
import { dom as f } from "./index339.js";
import { getOwnerDocument as T } from "./index343.js";
function y({ defaultContainers: t = [], portals: u, mainTreeNodeRef: v } = {}) {
  let o = d(null), a = T(o);
  function i() {
    var r, l, s;
    let n = [];
    for (let e of t) e !== null && (e instanceof HTMLElement ? n.push(e) : "value" in e && e.value instanceof HTMLElement && n.push(e.value));
    if (u != null && u.value) for (let e of u.value) n.push(e);
    for (let e of (r = a?.querySelectorAll("html > *, body > *")) != null ? r : []) e !== document.body && e !== document.head && e instanceof HTMLElement && e.id !== "headlessui-portal-root" && (e.contains(f(o)) || e.contains((s = (l = f(o)) == null ? void 0 : l.getRootNode()) == null ? void 0 : s.host) || n.some((h) => e.contains(h)) || n.push(e));
    return n;
  }
  return { resolveContainers: i, contains(r) {
    return i().some((l) => l.contains(r));
  }, mainTreeNodeRef: o, MainTreeNode() {
    return v != null ? null : m(c, { features: p.Hidden, ref: o });
  } };
}
function C() {
  let t = d(null);
  return { mainTreeNodeRef: t, MainTreeNode() {
    return m(c, { features: p.Hidden, ref: t });
  } };
}
export {
  C as useMainTreeNode,
  y as useRootContainers
};
